import { render, staticRenderFns } from "./ShipmentInquiryModal.vue?vue&type=template&id=6604c8e2&scoped=true&"
import script from "./ShipmentInquiryModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentInquiryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6604c8e2",
  null
  
)

export default component.exports